import BaseComponent from '@/js/core/BaseComponent'
import Events from '@/js/core/EventDispatcher'

export default class Header extends BaseComponent {
  static STICKY = 'header--sticky'
  static ACTIVE = 'header--active'

  static root = '.header'

  state = {
    ...this.state,
    prevScroll: 0,
    nextScroll: 0,
    sticky: false,
    active: false,
  }

  actions = {
    sticky: 'update',
    active: 'toggle',
  }

  selectors = {
    'openMenu': '[data-open-menu]',
  }

  listeners = {
    'click @openMenu': () => {
      Events.emit('menu:open', true)
    }
  }

  update () {
    const { sticky } = this.state
    this.$.el && 
    this.$.el[sticky 
      ? 'addClass' 
      : 'removeClass'
    ](Header.STICKY)
  }

  toggle () {
    const { active } = this.state
    this.$.el && 
    this.$.el[active 
      ? 'addClass' 
      : 'removeClass'
    ](Header.ACTIVE)
  }

  watch () {
    const scrollTop = this.$.win.scrollTop()
    this.setState(({ nextScroll }) => ({
      prevScroll: nextScroll,
      nextScroll: scrollTop,
      sticky: scrollTop > 0,
    }))

    const { nextScroll, prevScroll } = this.state
    const direction = nextScroll - prevScroll >= 0 ? 1 : -1
    this.setState(() => ({ active: direction < 0 }))
  }

  mounted () {
    super.mounted()
    this.$.win.on('scroll', () => 
      this.watch())
    this.watch()
  }
}